import { Component, Input, OnInit } from '@angular/core'
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'

import { QuestionChild } from '../question.component'
import { Question } from '../../../models/question'
import { Response } from '../../../models/response'
import { AnswerStatus, Answer } from '../../../models/answer'

@Component({
  selector: 'capto-question-text',
  templateUrl: './question-text.component.html',
  styleUrls: ['./question-text.component.scss']
})
export class QuestionTextComponent implements QuestionChild, OnInit {
  @Input()
  formId: string
  @Input()
  question: Question
  @Input()
  response: Response
  answer: Answer
  answerSelection: Subject<object> = new Subject()

  // use a subject to debounce the keyup call on the input
  answerValue: Subject<string> = new Subject()

  ngOnInit(): void {
    this.answer = this.question.answer
    this.answerValue
      .pipe(debounceTime(500))
      .subscribe(value => this.save(value))
  }

  save(value): void {
    if (value === '') {
      // need to return an empty values object when the user delete his answer
      this.answer = {
        values: {},
        status: null
      }
    } else {
      this.answer = {
        values: { [this.question.id]: { id: this.question.id, value } },
        status: AnswerStatus.Answered
      }
    }
    this.answerSelection.next(this.answer)
  }
}
